import { render, staticRenderFns } from "./EmailTestConfigurationModal.vue?vue&type=template&id=0d53382e&"
import script from "./EmailTestConfigurationModal.vue?vue&type=script&lang=js&"
export * from "./EmailTestConfigurationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports